export default __webpack_public_path__ + "static/media/carousel3.0fb389f6.jpg";